import * as React from 'react';

import styles from './CarouselSlide.css';
import { ScrollFade } from '@cian/adfox-templates';

export type CarouselSlidePros = {
  imageSrc: string;
  title: string;
  description: string;
};

export const CarouselSlide: React.FC<CarouselSlidePros> = props => {
  const { imageSrc, title, description } = props;
  const contentRef = React.useRef<HTMLDivElement>(null);

  /**
   * Скролл наверх при выходе мыши с карточки
   */
  const handleMouseLeave = () => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={styles['container']} onMouseLeave={handleMouseLeave}>
      <div className={styles['image-container']}>
        <img
          loading="lazy"
          decoding="async"
          alt={title}
          className={styles['image']}
          src={imageSrc}
          width="100%"
          height="100%"
        />
      </div>
      <div ref={contentRef} className={styles['content']}>
        <span className={styles['title']}>{title}</span>
        <span className={styles['description']}>{description}</span>
        <ScrollFade size={50} />
      </div>
    </div>
  );
};
